import { put } from 'redux-saga/effects'
import { REQUEST_UPLOAD_START } from 'store/sagas'

export default function * requestUploadStart (action) {
  const { boardId, file } = action.payload

  yield put({
    type: REQUEST_UPLOAD_START,
    payload: {
      file,
      boardId
    }
  })
}
